export class User {
    id: number;
    userId: number;
    userType: any='';
    lDebtorDocket: any;
    userName: string;
    username: string;
    firstName: string;
    lastName: string;
    password: string;
    email: string;
    accessToken: string;
    roles: number[];
    pic: string;
    name: string;
	phone: string;    
    status: any;
    new_password: string;
    confirmPassword: string;
    data: any;
    succeeded: boolean;
    debtorFirst: string;
    debtorLast: string;

    clear(): void {
        this.id = undefined;
        this.userId = undefined;
        this.username = '';
        this.password = '';
        this.email = '';
        this.roles = [];
        this.name = '';
        this.accessToken = 'access-token-' + Math.random();
        this.pic = './assets/media/users/user4.jpg';
        this.phone = '';
        this.new_password = '';
        this.confirmPassword = '';
        this.debtorFirst = '';
        this.debtorLast = '';
    }
}
